const firebaseConfig = {
    apiKey: "AIzaSyBFgWc3CJYG7SKZOyYRh8zTTTRa6xySZqE",
    authDomain: "ss-travel-guru.firebaseapp.com",
    databaseURL: "https://ss-travel-guru.firebaseio.com",
    projectId: "ss-travel-guru",
    storageBucket: "ss-travel-guru.appspot.com",
    messagingSenderId: "725092264088",
    appId: "1:725092264088:web:39efd98a9d2e1cfde608ed"
};

export default firebaseConfig;